module.exports = __webpack_public_path__ + "static/media/37F55A_0_0.b3283236.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/37F55A_0_0.woff
// module id = 737
// module chunks = 0